import React, { Component } from "react";
import { Link } from "react-router-dom";
import image from "../../../assets/images/callgage-about-thumbnail.jpg";
import "../../../styles/pages/home/HomeAboutUs.css";

export default class HomeAboutUs extends Component {
  render() {
    return (
      <div className="HomeAboutUs">
        <div className="content-container gutters">
          <div className="g-title mobile white on-scroll-anim">ABOUT US</div>

          {/* The Image */}
          <div className="image-container on-scroll-anim">
            <img src={image} alt="Gage and Derek at Chuck E. Cheese as kids." />
          </div>

          {/* The Text */}
          <div className="text-container">
            <div className="g-title desktop white on-scroll-anim">ABOUT US</div>
            <div className="g-sub-text white on-scroll-anim">
              The two goofballs trying to impress you.
            </div>
            <Link to="/about" className="g-button white on-scroll-anim">
              View More
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
